export class PageConfig {
	public defaults: any = {
		app:{
			tableaudebord: {
				page: {
					title: 'Tableau de bord et Statistiques',
					desc: 'Tableau de bord et Statsiqtiues'
				},
			},
			abonnements : {
				page:{
					title : 'Gestion',
					desc: 'Abonnement',
				}
			},
			clients : {
				page:{
					title : 'Gestion',
					desc: 'Clients',
				}
			},
			distributeurs : {
				page:{
					title : 'Gestion',
					desc: 'Distributeurs',
				}
			},
			factures : {
				page:{
					title : 'Gestion',
					desc: 'Factures',
				}
			},
			reglements : {
				page:{
					title : 'Gestion',
					desc: 'Reglement',
				}
			},
			packages : {
				page:{
					title : 'Paramètrages',
					desc: 'Packages',
				}
			},
			modules : {
				page:{
					title : 'Paramètrages',
					desc: 'Modules',
				}
			},
			parametres : {
				page:{
					title : 'Paramètrages',
					desc: 'Paramètre',
				}
			},
			distributeurtypes : {
				page:{
					title : 'Paramètrages',
					desc: 'Type de distributeur',
				}
			},
			tickets : {
				page:{
					title : 'Support',
					desc: 'Support',
				}
			},
			guides : {
				page:{
					title : 'Guide',
					desc: 'Guide',
				}
			}
		}
	};

	public get configs(): any {
		return this.defaults;
	}
}
